/*
 * File: /src/services/interestServices.js
 * Created Date: Monday May 31st 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Monday, 31st May 2021 12:29:02 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_INTERESTS_PATH } from '../constants';

export default {
  /**
   * Fetch Interests
   */
  fetchInterests() {
    return authedAxios.get(AD_BASE_INTERESTS_PATH);
  },

  /**
   * Fetch Interest By Id
   */
  fetchInterestById(id) {
    return authedAxios.get(AD_BASE_INTERESTS_PATH + id);
  },

  /**
   * Save Interests
   *
   * @param {number} [id=0]
   * @param {object} Interests Object
   * @returns
   */
  saveInterests(id = 0, body) {
    if (id) {
      return authedAxios.put(AD_BASE_INTERESTS_PATH + id, body);
    } else {
      const interest = body;
      delete interest.id;
      return authedAxios.post(AD_BASE_INTERESTS_PATH, interest);
    }
  },

  /**
   * Delete Interests
   */
  deleteInterestsById(id) {
    return authedAxios.delete(AD_BASE_INTERESTS_PATH + id);
  }
};
